/** @format */

import DashboardDocListItem from '@/app/[locale]/(protected)/(dashboard)/ui/DashboardDocListItem';
import CentredLoadingSpinner from '@atoms/CentredLoadingSpinner';
import { cssVars } from '@atoms/GlobalStyles/GlobalStyles';
import { DocumentClient } from '@common/model/apiClient';
import { ScrollView } from 'devextreme-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

interface RecentDocsProps {
  docs: Array<DocumentClient>;
  loading?: boolean;
}

const StyledRecentDocs = styled.div`
  background: var(--grey-100);
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  height: 100%;
  width: 100%;
  flex: 1;
`;

const RecentDocsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 16px;
  box-sizing: border-box;
  position: relative;
  > div {
    box-sizing: border-box;
  }
  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

const Header = styled.div`
  // background: ${cssVars.charcoal};
  // color: var(--grey-100);
  // display: flex;
  align-items: center;
  // padding: 0 8px;
  border-radius: 3px 3px 0 0;
  color: var(--grey-100);
  background: ${cssVars.charcoal};
  padding-inline: 8px;
  height: 45px;
  font-size: 1rem;
  display: flex;
  gap: 8px;
`;

function RecentDocs({ docs, loading }: RecentDocsProps) {
  return (
    <StyledRecentDocs>
      <Header>
        <span>
          <FormattedMessage defaultMessage={'Most Recent Documents'} description={'List of most recently created documents'} />
        </span>
      </Header>
      {loading ? (
        <CentredLoadingSpinner />
      ) : (
        <ScrollView showScrollbar={'onHover'} height={'100%'}>
          {/*<RecentDocsWrapper>{docs.map((doc) => <div>{doc.id}</div>)}</RecentDocsWrapper>*/}
          <RecentDocsWrapper>
            {docs.map((doc) => (
              <DashboardDocListItem key={`Document${doc.id}`} doc={doc} />
            ))}
          </RecentDocsWrapper>
        </ScrollView>
      )}
    </StyledRecentDocs>
  );
}

export default RecentDocs;
